var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCovidHeadGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 190",
    style: {
      enableBackground: "new 0 0 1080 190"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.4,101c22.8,0,41.3-18.5,41.3-41.3s-18.5-41.3-41.3-41.3s-41.3,18.5-41.3,41.3S153.6,101,176.4,101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.6,75.4c8.7,0,15.7-7,15.7-15.5c0-8.6-7-15.5-15.7-15.5s-15.7,7-15.7,15.5C233.9,68.4,241,75.4,249.6,75.4 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.8,92.4c18,0,32.7-14.6,32.7-32.7S340.9,27,322.8,27s-32.7,14.6-32.7,32.7S304.8,92.4,322.8,92.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396,71.3c6.7,0,12.1-5.3,12.1-11.8s-5.4-11.8-12.1-11.8s-12.1,5.3-12.1,11.8S389.3,71.3,396,71.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.2,101.6c23,0,41.6-18.6,41.6-41.6s-18.6-41.6-41.6-41.6S427.6,37,427.6,60S446.2,101.6,469.2,101.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.4,77.2c9.7,0,17.6-7.9,17.6-17.5c0-9.7-7.9-17.5-17.6-17.5s-17.6,7.9-17.6,17.5 C524.9,69.4,532.8,77.2,542.4,77.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 0,
    y1: 59.8,
    x2: 542.8,
    y2: 59.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606.4,59.9c0-6.5,4.8-12.3,14.1-12.3c2.2,0,4.3,0.6,5.6,1.3l2.5-0.5l0.3,7.7h-0.2l-4-7 c-0.6-0.4-2.4-0.9-4.2-0.9c-4.8,0-7.6,4.8-7.6,11.7c0,7.1,3.2,11.4,7.2,11.4c3.9,0,6.4-2,8-5.5l1.4-2.8h0.2l-1.2,7.2l-1.2,0.2 c-1.3,0.5-4.9,1.3-7.3,1.3C611.5,71.6,606.4,66.2,606.4,59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M634.4,59.6c0-6.6,6.1-12,13.1-12c7.4,0,12.6,4.9,12.6,12.1c0,6.6-6,11.9-13.1,11.9 C639.7,71.6,634.4,66.8,634.4,59.6z M653.6,59.7c0-7.8-2.1-11.6-6.4-11.6c-4.5,0-6.3,3.2-6.3,11.5c0,7.9,2.1,11.6,6.5,11.6 S653.6,68,653.6,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M666.5,52.9c-1.8-4-2.3-4.4-3.8-4.5l-1-0.1v-0.2H674v0.2h-1c-2.3,0.1-2.1,0.5-1,3l5.7,12.5h0.1l3.7-9.4 c2-5.3,2.4-5.7-1.1-6l-0.6-0.1l-0.1-0.2h7.9l-0.1,0.2l-0.7,0.1c-2.5,0.3-2.8,0.8-5,6.2l-6.6,16.7h-0.4L666.5,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M690.2,71l1.4-0.1c1.2-0.1,1.7-0.4,1.7-0.6V48.9c0-0.3-0.3-0.3-2.1-0.6l-1.1-0.1L690,48h12.5l-0.1,0.2 l-1.4,0.1c-1.2,0.1-1.7,0.4-1.7,0.6v21.2c0,0.3,0.3,0.3,2.1,0.5l1,0.1l0.1,0.2L690.2,71L690.2,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M706.5,71l1.4-0.1c1.3-0.2,1.7-0.4,1.7-0.6V48.9c0-0.3-0.3-0.3-2.1-0.6l-1-0.1l-0.1-0.2c0,0,12.9,0,12.3,0 c8.2,0,12.6,4,12.6,11.5c0,6.3-5.9,11.5-12.9,11.5h-12.1H706.5z M724.8,60.3c0-7.8-2.5-11.7-7.4-11.7h-1.8v21.7l2.5,0.5 C722.4,70.8,724.8,66,724.8,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M737.8,61.8h8.9l-0.1,1.5h-8.9L737.8,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M752,71h0.6c1.3-0.1,1.9-0.1,1.9-0.6V49.8l-3.1-0.4l0.1-0.2l8.5-1.4v22.6c0,0.3,0.8,0.4,2.1,0.5h0.5l0.1,0.2 h-10.8L752,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M767.8,72.5c6.9-1,10.8-7.1,11.8-11.7l-0.1-0.1c-1.8,1.4-3.6,2.1-5.4,2.1c-3.9,0-6.8-2.4-6.8-7 c0-4.9,4.2-8.4,9.4-8.4c5.6,0,9.2,3.9,9.2,9.9C785.9,65.5,777.8,71.9,767.8,72.5L767.8,72.5z M779.6,60.3c0.3-0.7,0.4-1.7,0.4-3.8 c0-4.1-0.7-8.8-3.6-8.8c-1.7,0-3.4,2.2-3.4,7c0,4.1,1.5,6.4,4.3,6.4C778.4,61.2,779.1,60.7,779.6,60.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidHeadGraphic);
export default __webpack_public_path__ + "static/media/COVID-HeadGraphic.282ba90bc52e89b4b24a0be6ff7f4071.svg";
export { ForwardRef as ReactComponent };